import { AnyRecord } from "dns"
import { useEffect, useState } from "react"

export interface RegisterImgProps {
    data: any

    onChange: (data: any) => void
    onRemove: () => void
}

export default function RegisterImg(props: RegisterImgProps) {

    const [value, setValue] = useState(props.data ? props.data : '');

    useEffect(() => {
        props.onChange({...props.data, image_gallery: value})
    }, [value])

    return (<>
        <div style={{border: "1px solid #cecece", padding:"0 10px 18px 10px",marginBottom:"20px", backgroundColor:"white"}}>
            
            <div>
                <label> Image link{" "} </label>
                <div className="image_card">
                    <img src={value} height="auto" width="50px"  style={{border: "1px solid #cecece", borderRadius:"5px"}}></img>
                    <input type="url" className="issuer-form image_gallery" name="image_gallery" maxLength={1000} placeholder="e.g., https://www.example-gallery.com" value={value} onChange={(event) => { setValue(event.target.value); }}  ></input>
                </div>
            </div>           

            <div style={{height:"20px",marginTop:"10px"}}>
                <button type="button" className="form_btn" onClick={props.onRemove}>Remove </button>
            </div>
            
        </div>
    </>)
}